import api from './api';
import { Tenant, ApiResponse } from '../types';

export const tenantService = {
  listar: async (): Promise<Tenant[]> => {
    const response = await api.get<Tenant[]>('/tenants');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Tenant> => {
    const response = await api.get<Tenant>(`/tenants/${id}`);
    return response.data;
  },

  cadastrar: async (tenant: Tenant): Promise<ApiResponse<Tenant>> => {
    const response = await api.post<ApiResponse<Tenant>>('/tenants', tenant);
    return response.data;
  },

  atualizar: async (id: number, tenant: Tenant): Promise<ApiResponse<Tenant>> => {
    const response = await api.put<ApiResponse<Tenant>>(`/tenants/${id}`, tenant);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/tenants/${id}`);
    return response.data;
  },

  reativar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.put<ApiResponse<void>>(`/tenants/${id}/reativar`);
    return response.data;
  },
};
